// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Toggle_wrapper__141Pw","mode":"Toggle_mode__1mlsH","active":"Toggle_active__lB9VL","singleModeToggle":"Toggle_singleModeToggle__15Zqs"};